import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NAME_REDUCER } from './constants';
import actions from './actions';
import moment from 'moment';
import type { NotificationPage } from 'types/models';

export interface NotificationState {
  params: string;
  date: string;
  // unused; carried over from the appt-reducer template this slice was copied from
  appointments: unknown[];
  blockHours: unknown[];
  loading: boolean;
  notifications: NotificationPage | null;
  // success payload (an object, per NotificationButton's `unreadCount.unreadCount` read)
  // conflicts with this field's own initial value below (a plain number) — latent
  // inconsistency in the pre-existing code, kept as-is rather than "fixed"
  unreadCount: any;
}

const initialState: NotificationState = {
  params: '',
  date: moment().format(),
  appointments: [],
  blockHours: [],
  loading: false,
  notifications: null,
  unreadCount: 0,
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {
    setDate: (state, { payload }: PayloadAction<string>) => {
      state.date = payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(actions.getNotifications.success, (state, { payload }) => {
        console.log(payload.page);

        if (payload.page <= 0) {
          state.notifications = payload;
          return;
        }

        // non-null: only reachable once a prior page-0 fetch has populated notifications;
        // if a page>0 fetch ever arrived first this would throw, matching original JS behavior
        const notifications = state.notifications!.content;
        state.notifications = payload;

        state.notifications.content = [...notifications, ...payload.content];
      })
      .addCase(actions.setNotifications, (state, { payload }) => {
        state.notifications = payload;
      })
      .addCase(actions.countNotificationUnread.success, (state, { payload }) => {
        state.unreadCount = payload;
      })
  },
});
export const notificationUIActions = Slice.actions;
const notificationServiceReducer = Slice.reducer;
export default notificationServiceReducer;
